<template>
  <v-container fluid class="renewals">
    <v-card flat v-if="$route.name !== 'registrationCards'">
      <v-card-title class="renewals overline text--center">
        Current Registration &nbsp;
        <v-chip color="primary renewals" small>{{
          currentRegistration ? currentRegistration.status : "unknown status"
        }}</v-chip>
        <v-spacer />
        <v-btn icon @click="show = !show">
          <v-icon>{{ show ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
        </v-btn>
      </v-card-title>

      <v-expand-transition>
        <v-card-text v-show="show">
          <v-row>
            <v-col cols="12" md="12" lg="4">
              <v-card flat class="renewals">
                <v-card-text>
                  <v-row>
                    <v-col
                      class="d-flex flex-column justify-center text-center overline"
                    >
                      <h1 class="renewals primary--text">
                        {{
                          currentRegistration
                            ? currentRegistration.programme
                            : "NONE"
                        }}
                      </h1>
                      <strong class="renewals">Current Programme</strong>
                    </v-col>
                  </v-row>
                </v-card-text>

                <v-card-actions>
                  <v-sheet
                    class="overline px-3 d-flex flex-column text-center align-items-center"
                  >
                    <h6 class="caption primary--text">
                      {{
                        currentRegistration
                          ? currentRegistration.intakeYear
                          : ""
                      }}
                    </h6>
                    <h4 class="renewals">Year</h4>
                  </v-sheet>
                  <v-spacer />
                  <v-sheet
                    class="overline px-3 d-flex flex-column text-center align-items-center"
                  >
                    <h6 class="caption primary--text">
                      {{
                        currentRegistration
                          ? currentRegistration.intakeSemester
                          : ""
                      }}
                    </h6>
                    <h4 class="renewals">Semester</h4>
                  </v-sheet>
                  <v-spacer />
                  <v-sheet
                    class="overline px-3 d-flex flex-column text-center align-items-center"
                  >
                    <h6 class="caption primary--text">
                      {{
                        currentRegistration
                          ? currentRegistration.intakeStage
                          : ""
                      }}
                    </h6>
                    <h4 class="renewals">Part</h4>
                  </v-sheet>
                </v-card-actions>
              </v-card>
            </v-col>

            <v-col v-if="$vuetify.breakpoint.smAndDown" cols="12">
              <v-divider />
            </v-col>
            <v-divider v-else vertical />

            <v-col cols="12" md="12" lg="5">
              <v-row>
                <v-col cols="12" md="12" lg="12">
                  <v-simple-table dense class="caption">
                    <tbody>
                      <tr>
                        <th class="renewals">Faculty</th>
                        <th>
                          {{
                            currentRegistration
                              ? currentRegistration.programmeAPI
                                ? currentRegistration.programmeAPI.faculty
                                : "-"
                              : ""
                          }}
                        </th>
                      </tr>
                      <tr>
                        <th class="renewals">Units Taken</th>
                        <th>
                          {{
                            currentRegistration
                              ? currentRegistration.totalTakenUnits || "-"
                              : ""
                          }}
                        </th>
                      </tr>
                      <tr>
                        <th class="renewals">Units Exempted</th>
                        <th>
                          {{
                            currentRegistration
                              ? currentRegistration.totalExemptedUnits || "-"
                              : ""
                          }}
                        </th>
                      </tr>
                      <tr>
                        <th class="renewals">Total Paid</th>
                        <th>
                          {{
                            currentRegistration
                              ? currentRegistration.totalPaid || "-"
                              : ""
                          }}
                        </th>
                      </tr>
                      <tr>
                        <th class="renewals">Balance</th>
                        <th>
                          {{
                            currentRegistration
                              ? currentRegistration.balance || "-"
                              : ""
                          }}
                        </th>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </v-col>
              </v-row>
            </v-col>

            <v-col v-if="$vuetify.breakpoint.smAndDown" cols="12">
              <v-divider />
            </v-col>
            <v-divider v-else vertical />

            <v-col cols="12" md="12" lg="3">
              <v-list dense>
                <v-list-item-group>
                  <v-list-item dense>
                    <v-list-item-title>Reg No:</v-list-item-title>
                    <v-list-item-subtitle>
                      <v-chip label small>
                        {{
                          currentRegistration
                            ? currentRegistration.registrationID
                            : ""
                        }}
                      </v-chip>
                    </v-list-item-subtitle>
                  </v-list-item>

                  <v-list-item dense>
                    <v-list-item-title>Name:</v-list-item-title>
                    <v-list-item-subtitle>
                      {{ student ? student.searchName : "" }}
                    </v-list-item-subtitle>
                  </v-list-item>

                  <v-list-item dense>
                    <v-list-item-title>Status:</v-list-item-title>
                    <v-list-item-subtitle>
                      <v-chip
                        label
                        small
                        class="white--text"
                        color="green lighten-1"
                      >
                        {{ student ? student.status : "" }}
                      </v-chip>
                    </v-list-item-subtitle>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-col>
          </v-row>
        </v-card-text>
      </v-expand-transition>
      <v-divider />
      <v-card-text>
        <RenewalList :renewals="renewals" />
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import { AuthService } from "../../dashboard/modules/auth";
import RenewalList from "./RenewalList";
export default {
  name: "CurrentRegistration",
  components: { RenewalList },
  data: () => ({
    show: true,
    mainMenu: false,
    renew: false,
    retakeDialog: false,
  }),
  beforeRouteEnter(to, from, next) {
    next((v) => {
      v.$store.dispatch("Renewal/getStudentProgrammes");
      v.$store.dispatch("Renewal/getSetupProgrammes");
      v.$store.dispatch("Renewal/getSemesters");
      v.$store.dispatch("Renewal/getprogrammeStages");
      v.$store.dispatch("Renewal/getRenewals");
    });
  },
  computed: {
    renewals() {
      return this.$store.getters["Renewal/renewalGetters"]("renewals");
    },
    currentProgramme() {
      return this.$store.getters["Renewal/currentProgramme"];
    },
    currentRegistration() {
      const prog = this.currentProgramme[0];
      return prog
        ? {
            ...prog,
            programmeAPI: prog.programmeAPI,
          }
        : null;
    },
    setupProgrammes() {
      return this.$store.getters["Renewal/setupProgrammes"];
    },
    programmeStages() {
      return this.$store.getters["Renewal/programmeStages"];
    },
    semesters() {
      return this.$store.getters["Renewal/semesters"];
    },
    studentUnits() {
      const currReg = this.currentRegistration
        ? this.currentRegistration
        : null;
      return currReg ? currReg.studentunits : [];
    },
    student() {
      return AuthService.user.student;
    },
  },
  methods: {
    setRetakeDialog(value) {
      this.retakeDialog = value;
    },
    navigateRenew() {
      this.renew = !this.renew;
      this.$router.replace({
        path: "registrationCards",
        query: {
          programme: this.currentRegistration
            ? this.currentRegistration.programme
            : "",
        },
      });
    },
  },
};
</script>

<style scoped>
@import url("../styles/renewal.css");
</style>
